import { io } from 'socket.io-client';

const SOCKET_URL = 'http://custom-dev.onlinetestingserver.com:9997';

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  connect(token) {
    if (this.socket?.connected) {
      return this.socket;
    }

    this.socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      auth: {
        token: token
      },
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket.id);
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
      this.isConnected = false;
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  // Chat specific methods
  joinChat(chatId) {
    this.emit('join_chat', { chat_id: chatId });
  }

  leaveChat(chatId) {
    this.emit('leave_chat', { chat_id: chatId });
  }

  sendMessage(data) {
    this.emit('send_message', data);
  }

  onNewMessage(callback) {
    this.on('new_message', callback);
  }

  offNewMessage(callback) {
    this.off('new_message', callback);
  }

  onMessageSent(callback) {
    this.on('message_sent', callback);
  }

  offMessageSent(callback) {
    this.off('message_sent', callback);
  }

  onChatListUpdate(callback) {
    this.on('chat_list_update', callback);
  }

  offChatListUpdate(callback) {
    this.off('chat_list_update', callback);
  }

  onTyping(callback) {
    this.on('user_typing', callback);
  }

  offTyping(callback) {
    this.off('user_typing', callback);
  }

  emitTyping(chatId) {
    this.emit('typing', { chat_id: chatId });
  }

  emitStopTyping(chatId) {
    this.emit('stop_typing', { chat_id: chatId });
  }
}

const socketService = new SocketService();

export default socketService;

